import { useState, useEffect } from 'react';

export const useClock = () => {
  const [time, setTime] = useState('');
  const [date, setDate] = useState('');

  const updateClock = () => {
    const now = new Date();
    const timeString = now.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
    const dateString = now.toLocaleDateString('en-GB');
    
    setTime(timeString);
    setDate(dateString);
  };

  useEffect(() => {
    updateClock();
    const interval = setInterval(updateClock, 1000);
    
    return () => clearInterval(interval);
  }, []);

  return { time, date };
};
